import AssetLibrary from "../../../../core/assetloading/AssetLibrary";
import DashboardConfig from "../../model/DashboardConfig";
import DashboardData from "../../model/DashboardData";
import DashboardTabMediator from "./DashboardTabMediator";

export default class DashboardRCCETabMediator extends DashboardTabMediator {
    /**
     * 
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} layoutManager 
     * @param {*} clickEaterFactory 
     * @param {*} languagePack 
     * @param {DashboardData} dashboardData 
     * @param {*} progressGameModel 
     * @param {AssetLibrary} assetLibrary
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardData, progressGameModel, assetLibrary) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._dashboardData = dashboardData;
        this._progressGameModel = progressGameModel;
        this._assetLibrary = assetLibrary;
    }

    initialize() {
        super.initialize();
        const week = this._progressGameModel.week;
        const movieClipName = this._dashboardData.getCurrentRcceMovieClipId(week);
        this._initializeImageContainer(movieClipName);
    }

    _initializeImageContainer(movieClipId) {
        this._target.imageContainer.removeAllChildren();
        // const illustration = new lib.MainAssets[movieClipId];
        const illustration = this._assetLibrary.tryGetBitmapFromImageId("MainAssets_Translated_" + movieClipId);
        this._target.imageContainer.addChild(illustration);
    }

    destroy() {
        super.destroy();
    }
    get skin() {
        return this._target;
    }
}